import React, {type ReactNode} from 'react'
import clsx from 'clsx'
import styles from './MoreMenuGroup.module.scss'
import {type TranslationObject} from '@colonist/i18n'
import {T} from '@colonist/ui'

export interface MoreMenuGroupProps {
    className?: string
    headerText: TranslationObject
    children: ReactNode
}

export const MoreMenuGroup = ({
    className,
    headerText,
    children,
}: MoreMenuGroupProps) => (
    <div className={clsx(styles.group, className)}>
        <h3 className={styles.headerText}><T id={headerText} /></h3>
        <div className={styles.container}>
            {children}
        </div>
    </div>
)
